import { heapTrackProperties } from '@m/utils/heap';

import type { OnboardingVariant } from './deriveVariant';

export type OnboardingAnalyticsStep =
  'ContactInfo' | 'Payment' | 'Phone' | 'ReviewSubscription' | 'Success' | 'Vehicle' | 'VerifyCode';

const FLOW_LABEL: Record<OnboardingVariant, string> = {
  agnostic: 'Agnostic Sign-up',
  enterpriseSub: 'Enterprise Sign-up',
  individualSub: 'Individual Sub Sign-up',
  locationSpecific: 'Start Visit',
};

function track(
  action: 'Completed' | 'Skipped' | 'Viewed',
  step: OnboardingAnalyticsStep,
  variant: OnboardingVariant,
  optional: boolean,
  props: Record<string, boolean> = {},
) {
  heapTrackProperties(`SignInOnboarding:${step}:${action}`, {
    ...props,
    flow: FLOW_LABEL[variant],
    optional,
  });
}

export function trackOnboardingStepViewed(
  step: OnboardingAnalyticsStep,
  variant: OnboardingVariant,
  optional = false,
) {
  track('Viewed', step, variant, optional);
}

export function trackOnboardingStepCompleted(
  step: OnboardingAnalyticsStep,
  variant: OnboardingVariant,
  optional = false,
) {
  track('Completed', step, variant, optional);
}

export function trackOnboardingStepSkipped(
  step: OnboardingAnalyticsStep,
  variant: OnboardingVariant,
  optional = true,
) {
  track('Skipped', step, variant, optional);
}

/**
 * `Completed` fires when any contact field has a value, including values pre-filled from the
 * account, so these flags say which fields were actually submitted. `emailPrefilled` separates
 * an email already on file from one the customer added on this page.
 */
export function trackContactInfoCompleted(
  variant: OnboardingVariant,
  optional: boolean,
  fields: {
    addedEmail: boolean;
    addedName: boolean;
    emailPrefilled: boolean;
    namePrefilled: boolean;
  },
) {
  track('Completed', 'ContactInfo', variant, optional, fields);
}
